(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spare-hours-shop"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sh-club-catalog')) {
 class SpareHoursCatalog extends HTMLElement {
  connectedCallback() {
   if (this.initialized) return;
   this.initialized = true;
   const controls = this.querySelector('.shs-filters');
   const buttons = Array.from(controls.querySelectorAll('button'));
   const cards = Array.from(this.querySelectorAll('.shs-card'));
   const status = this.querySelector('.shs-filter-status');
   const empty = this.querySelector('.shs-empty');
   controls.hidden = false;
   controls.addEventListener('click', event => {
    const button = event.target.closest('button[data-region]');
    if (!button || !controls.contains(button)) return;
    const region = button.dataset.region;
    let count = 0;
    for (const card of cards) {
     const visible = region === 'all' || card.dataset.regions.split(' ').includes('region-' + region);
     card.hidden = !visible;
     if (visible) count++;
    }
    for (const control of buttons) control.setAttribute('aria-pressed', String(control === button));
    status.textContent = (count === 1 ? this.dataset.one : this.dataset.other).replace('__COUNT__', String(count));
    empty.hidden = count > 0;
   });
  }
 }
 customElements.define('sh-club-catalog', SpareHoursCatalog);
}

  } catch(e) { console.error(e); }
})();
})();
